export const makeFullUrl = (str) => {
  try {
    const link = new URL(str);
    return link.href;
  } catch (error) {
    return window.location.origin + str;
  }
};

export const getZipFromGAddress = (loc) => {
  if (loc?.length) {
    const zipAddress = loc[0].address_components.find((item) =>
      item.types.includes('postal_code'),
    );
    return zipAddress?.long_name || loc[0].formatted_address || '';
  }
  return '';
};

export const vendorResultsViewedEvent = ({
  productCategory,
  contentType,
  zipCode,
  numberOfResults,
  vendorType,
}) => {
  window.dataLayer = window.dataLayer || [];
  let numberOfResultsString = 'no result';
  if (numberOfResults > 0 && numberOfResults < 6) {
    numberOfResultsString = '1-5 results';
  } else if (numberOfResults > 5) {
    numberOfResultsString = 'over 5 results';
  }
  if (numberOfResultsString !== 'no result') {
    return {
      event: 'vendor_results_viewed',
      event_origin: 'front_end',
      product_category: productCategory,
      content_type: contentType,
      zip_code: zipCode,
      number_of_results: numberOfResultsString,
      vendor_type: vendorType,
    };
  }
  window.dataLayer.pop({
    event: 'vendor_results_viewed',
  });
  return false;
};

export const projectDetailsProvidedEvent = ({
  contentType,
  filterName,
  filterValue,
}) => {
  return {
    event: 'project_details_provided',
    event_origin: 'front_end',
    content_type: contentType,
    filter_name: filterName,
    filter_value: filterValue,
  };
};

export const projectDetailsLoaded = ({
  productCategory,
  location,
  contentType,
}) => {
  const zip = getZipFromGAddress(location);

  return {
    event: 'project_details_loaded',
    event_origin: 'front_end',
    vendor_type: 'null',
    content_type: contentType,
    product_category: productCategory || 'null',
    zip_code: zip || 'null',
  };
};

export const getNumberOfResultsString = (n) => {
  let result;

  if (!n || n < 1) {
    result = 'no result';
  } else if (n <= 5) {
    result = '1-5 results';
  } else {
    result = 'over 5 results';
  }

  return result;
};

export const viewSearchResults = ({
  searchTerm,
  numberOfResults,
  elementLocation,
  contentType,
}) => {
  return {
    event: 'view_search_results',
    event_origin: 'front_end',
    search_term: searchTerm,
    number_of_results: getNumberOfResultsString(numberOfResults),
    element_location: elementLocation,
    content_type: contentType,
  };
};

export default {};
